// NATIVE 
import { useSelector } from 'react-redux';


// INSTALLED 
import { Box, Typography, Grid, Chip } from '@mui/material'


// CUSTOM 
import { formatDateToYmd, formatDateToYmdNumeric } from 'commons/utils'
import { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SinDatos } from 'components/generics/SinDatos';
import { DetailsComponents } from 'components/DetailsComponents';
import { ModalViewPdfGlobal } from 'components/modals/viwerPdf/ModalViewPdfGlobal';



/**
 * DetalleInformacionLaboral is a React functional component that displays detailed labor information
 * about an employee. It uses Material-UI components such as Grid, Box, and Typography to structure
 * and style the layout.
 *
 * The component retrieves employee data from the Redux store using the `useSelector` hook and displays
 * various personal and labor-related details, including:
 * - Personal information (name, identification number, address, phone, civil status)
 * - Family information (spouse, parents, children under 15 years old)
 * - Labor information (position, salary, contract type, medical exam results)
 * - Social security affiliations (ARL, EPS, pension, family compensation fund)
 * - Required documentation for employment (contract, CV, interview, ID copy, technical test, etc.)
 *
 * Each section is visually separated and styled with borders and background colors to enhance readability.
 *
 * @returns {JSX.Element} The rendered component displaying the employee's detailed labor information.
 */
export const DetalleInformacionLaboral = ({ onOpenPdf }: any) => {


  // USE SELECTOR 
  const { employee }:any  = useSelector( (state:any) => state.employee );

  // NAVIGATE 
  const navigate = useNavigate();



  const [dataEmployee, setDataEmployee] = useState<any>({
        id: 'N/A',
        name: 'N/A',
        last_name: 'N/A',
        address: 'N/A',
        neighborhood: 'N/A',
        email: 'N/A',
        landline: 'N/A',
        cell_phone: 'N/A',
        birthdate: new Date(),
        rh: 'N/A',
        dominance: 'N/A',
        stratum: 'N/A',
        type_contract: 'N/A',
        employee_avatar: 'N/A',
        examen_medico_name_saved: 'default.pdf',
        status: false,
        arl_name_saved: 'default.pdf',
        seguridadSocial: [],
        documentracionRequerida: [],
        position:{
          name: 'N/A'
  
        },
        saving: {
          name: 'N/A'
        },
        eps: {
          name: 'N/A'
        },
        retirement: {
          name: 'N/A'
        },
        familyCompensationFund: {
          name: 'N/A'
        },
        salary: 'N/A',
        contract_type: 'N/A',
        medical_results: 'N/A',
        arl: 'N/A',
        pension: 'N/A',
        family_compensation_fund: 'N/A',
        contract: 'N/A',
        cv: 'N/A',
        interview: 'N/A',
        id_copy: 'N/A',
        technical_test: 'N/A',  
        civil_status: 'N/A',
        document_type: 'N/A',
        document_number: 'N/A',
        expedition_place: 'N/A',
        expedition_date: new Date(),
        gender: 'N/A',
        date_of_birth: new Date(),
        date_start_contract: new Date(),
        salary_base: 'N/A',
        account_number: 'N/A',
        examen_medico: false,
        cv_name_saved_name: 'N/A',
        entrevista: 'N/A',
        cedula_name_saved_name: 'N/A',
        prueba_psicotecnica: false,
        sociodemografica: false,
        certificado_laboral: false,
        verificacion_adres: false,
        compromiso_sst: false,
        beneficiaries: [],
      });



      useEffect(() => {
          if ( employee && Object.keys(employee).length > 0 ) {
              setDataEmployee(employee);
          }
      }, [employee]);



        
        const openPdfDetail = (pdfFileName:string, pdfTypeUrl:string) => {
          // setUrlRutPdf(pdfFileName);
          // setShowPdfDetail(!showPdfDetail)
          onOpenPdf(pdfFileName, pdfTypeUrl)
          
        }
      // FIN PARA VISOR PDF 




  return (

    <div>
      
      {/* DETALLE RUT  */}
        {
          // showRutDetail && <ModalViewPdf open={showRutDetail} typeUrl="customer-pdf"  onClose={  setShowRutDetail } pdfUrl={urlRutPdf} />
          //showPdfDetail && <ModalViewPdfGlobal open={showPdfDetail} typeUrl="document-employees"  onClose={  setShowPdfDetail } pdfUrl={urlRutPdf} />
        }
      {/* FIN DETALLE RUT  */}


      <Grid container spacing={1} sx={{ marginTop: 3 }}>

        <Grid size={{ xs: 4 }} style={{border: "1px solid #192a56", textAlign: 'center'}}>
           <img src=" https://pance122.qihotels.net/img_compania/img/qihotels_pance122/image_6005dfe86b00d.png " style={{width: '59%'}} alt="" />
        </Grid>

        <Grid size={{ xs: 4 }} style={{border: "1px solid #192a56", textAlign: 'center'}}>
            &nbsp;
               <div className="col-12"><b>HOJA DE RUTA DE PERSONAL</b></div>
             &nbsp;
        </Grid>

        <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Grid  style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>CODIGO</Grid>

            <Grid  style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>VERSION</Grid>

            <Grid  style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>FECHA <small>d/m/y</small> </Grid>
        </Grid>

        <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Grid size={{ xs: 12 }} style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>FM - GH - 07</Grid>

            <Grid size={{ xs: 12 }} style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>2</Grid>

            <Grid size={{ xs: 12 }} style={{border: "1px solid #192a56", fontWeight: 'bolder'}}>{ formatDateToYmdNumeric( new Date()) }</Grid>
        </Grid>


        
        {/* ********** */}
        <Grid  size={{ xs: 12 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >DATOS PERSONALES</Typography>
          </Box>
        </Grid>
        {/* ********** */}



        {/* *********** */}
        <Grid size={{ xs: 4 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >NOMBRE Y APELLIDOS</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 8 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >   
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { `${dataEmployee?.name || ''} ${dataEmployee?.last_name || ''}` }</Typography>
          </Box>
        </Grid>
        {/* ********** */}
  

        {/* *********** */}
        <Grid size={{ xs: 4 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >NÚMERO DE IDENTIFICACIÓN</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 8 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > { dataEmployee.document_number }</Typography>
          </Box>
        </Grid>
        {/* ********** */}


        {/* *********** */}
        <Grid size={{ xs: 4 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >DIRECCIÓN</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 8 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{ dataEmployee.address}</Typography>
          </Box>
        </Grid>
        {/* ********** */}




        {/* *********** */}
        <Grid size={{ xs: 4 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >TELÉFONO</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 8 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{ dataEmployee.cell_phone}</Typography>
          </Box>
        </Grid>
        {/* ********** */}



        {/* *********** */}
        <Grid size={{ xs: 4 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ESTADO CIVIL</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 8 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{ dataEmployee.civil_status }</Typography>
          </Box>
        </Grid>
        {/* ********** */}




        
        {/* ********** */}
        <Grid  size={{ xs: 12 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >INFORMACIÓN FAMILIAR</Typography>
          </Box>
        </Grid>
        {/* ********** */}


        {/* ***** INFORMACION FAMILIAR HEADER****** */}
        <Grid size={{ xs: 3 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >PARENTESCO</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >NOMBRE</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >OCUPACION</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >EDAD</Typography>
          </Box>
        </Grid>
        {/* ********** */}

        

        {/* ***** INFORMACION FAMILIAR DATOS ****** */}
        {

          dataEmployee.beneficiaries.length > 0 
          ?
            dataEmployee.beneficiaries.map((item:any) => (
               <>
                <Grid size={{ xs: 3 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
                  <Box
                      sx={{
                        textAlign: 'center',
                        height: '100%',
                        alignContent: 'center'
                      }}
                    >
                    <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{item.parentesco.toUpperCase() || 'N/A'}</Typography>
                  </Box>
                </Grid>
                <Grid size={{ xs: 3 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
                  <Box
                      sx={{
                        textAlign: 'center',
                        height: '100%',
                        alignContent: 'center'
                      }}
                    >
                    <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{item.nombre+ ' '+ item.apellido || 'N/A'}</Typography>
                  </Box>
                </Grid>
                <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
                  <Box
                      sx={{
                        textAlign: 'center',
                        height: '100%',
                        alignContent: 'center'
                      }}
                    >
                    <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{item.ocupacion || 'N/A'}</Typography>
                  </Box>
                </Grid>
                <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
                  <Box
                      sx={{
                        textAlign: 'center',
                        height: '100%',
                        alignContent: 'center'
                      }}
                    >
                    <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{item.edad || 'N/A'}</Typography>
                  </Box>
                </Grid>
               </>
              
              
            ))
          :
          <SinDatos/>
  

        }
        {/* ********** */}







        


        
     
          
        {/* ***** RELACIONE HIJOS MENORES DE 15 AÑOS HEADER ****** */}
        <Grid  size={{ xs: 12 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >RELACIONE HIJOS MENORES DE 15 AÑOS</Typography>
          </Box>
        </Grid>
        {/* ********** */}


        {/* *********** */}
        <Grid size={{ xs: 6 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >NOMBRE</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >ESCOLARIDAD</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >EDAD</Typography>
          </Box>
        </Grid>
        {/* ********** */}



        {/* *********** */}
          {
            dataEmployee.beneficiaries.length > 0 
              ? (() => {
                  const mayores15 = dataEmployee.beneficiaries.filter((item: any) => {
                    const edadTexto = item.edad?.toLowerCase() || "";
                    const edadNumero = parseInt(edadTexto, 10);
                    return edadTexto.includes("año") && edadNumero < 15;
                  });

                  return mayores15.length > 0 ? (
                    mayores15.map((item: any, index: number) => (
                      <Fragment key={index}>
                        <Grid size={{ xs: 6 }} style={{border: "1px solid #192a56", textAlign: 'center', padding: 0}}>
                          <Box
                            sx={{
                              textAlign: 'center',
                              height: '100%',
                              alignContent: 'center'
                            }}
                          >
                            <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }}>
                              {item.nombre + ' ' + item.apellido || 'N/A'}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid size={{ xs: 3 }} style={{border: "1px solid #192a56", textAlign: 'center', padding: 0}}>
                          <Box
                            sx={{
                              textAlign: 'center',
                              height: '100%',
                              alignContent: 'center'
                            }}
                          >
                            <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }}>
                              {item.escolaridad || 'N/A'}
                            </Typography>
                          </Box>
                        </Grid>

                        <Grid size={{ xs: 3 }} style={{border: "1px solid #192a56", textAlign: 'center', padding: 0}}>
                          <Box
                            sx={{
                              textAlign: 'center',
                              height: '100%',
                              alignContent: 'center'
                            }}
                          >
                            <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }}>
                              {item.edad || 'N/A'}
                            </Typography>
                          </Box>
                        </Grid>
                      </Fragment>
                    ))
                  ) : (
                    <SinDatos/>
                  );
                })()
              : <SinDatos/>
          }


        {/* ********** */}



      



     
           {/* *********** */}
          <Grid size={{ xs: 8 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem' }} >DATOS LABORALES</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem' }} >EXAMEN INGRESO</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem' }} >EXAMEN EGRESO</Typography>
            </Box>
          </Grid>
          {/* *********** */}

       
         
          {/* *********** */}
          <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >CARGO</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs:5 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >{ dataEmployee?.position?.name || 'Sin asignar' }</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
                {/* INGRESO CARGO  */}
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >N/A</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
                {/* EGRESO CARGO  */}
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >N/A</Typography>
            </Box>
          </Grid>
          {/* *********** */}


          {/* *********** */}
          <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >SALARIO</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs:5 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >$ { dataEmployee.salary_base }</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
                {/* INGRESO SALARIO */}
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >N/A</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
                {/* EGRESO SALARIO  */}
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >N/A</Typography>
            </Box>
          </Grid>
          {/* *********** */}


          {/* *********** */}
          <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >FECHA INGRESO</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs:5 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} > { formatDateToYmd(dataEmployee.date_start_contract) }  </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
                {/* INGRESO FECHA CONTRATO  */}
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >N/A</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
                {/* EGRESO FECHA CONTRATO  */}
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >N/A</Typography>
            </Box>
          </Grid>
          {/* *********** */}
        



          {/* *********** */}
          <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >NÚMERO DE CUENTA</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs:5 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >{ dataEmployee.account_number }</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
                {/* INGRESO NUMERO CUENTA  */}
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >N/A</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
                {/* EGRESO NUMERO CUENTA  */}
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >N/A</Typography>
            </Box>
          </Grid>
          {/* *********** */}


          {/* *********** */}
          <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >TIPO DE CONTRATO</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs:5 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >{ (typeof dataEmployee?.contract === 'object' && dataEmployee?.contract ? (dataEmployee.contract as any).name : undefined) || (typeof dataEmployee?.type_contract === 'object' && dataEmployee?.type_contract ? (dataEmployee.type_contract as any).label : undefined) || (typeof dataEmployee?.type_contract === 'string' ? dataEmployee?.type_contract : 'N/A') }</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
                {/* INGRSO TIPO CONTRATO  */}
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >N/A</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
                {/* EGRESO TIPO CONTRATO  */}
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >N/A</Typography>
            </Box>
          </Grid>
          {/* *********** */}
        

          {/* *********** */}
          <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >CONCEPTO EXAMEN MÉDICO</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs:5 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} > { (dataEmployee.examen_medico) ? <Chip size='small' label="Apto" sx={{ color: "#fff", fontWeight: 700, background: "linear-gradient(45deg, #11998e 0%, #38ef7d 100%)" }} /> : <Chip size='small' label="No Apto" sx={{ color: "#fff", fontWeight: 700, background: "linear-gradient(45deg, #FF416C 0%, #FF4B2B 100%)" }} /> } </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >
                  
                  <div onClick={ () => openPdfDetail(dataEmployee.examen_medico_name_saved, "document-employees") }>
                    <DetailsComponents />
                  </div>

              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
            <Box
                sx={{
                  textAlign: 'center',
                  height: '100%',
                  alignContent: 'center'
                }}
              >
                {/* EGRESO DATOS LABORALES  */}
              <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >N/A</Typography>
            </Box>
          </Grid>
          {/* *********** */}

        











        {/* ***************************************************************************************************
        ****************************************************************************************************
        *********************************       INICIO        **********************************************
        ****************************************************************************************************
        *************************************************************************************************** */}


         {/* ***** AFILIACIONES SEGURIDAD SOCIAL HEADER ***** */}
        <Grid  size={{ xs: 12 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >AFILIACIONES SEGURIDAD SOCIAL</Typography>
          </Box>
        </Grid>
        {/* ********** */}



        {/* ***** AFILIACIONES SEGURIDAD SOCIAL TABLA ***** */}
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >AFILIACIÓN</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >ESTADO</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >INGRE</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >EGRE</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 1 }} >ENTIDAD</Typography>
          </Box>
        </Grid>


        {/* ***** AFILIACIONES SEGURIDAD SOCIAL DATOS ***** */}
      
        {

          dataEmployee.seguridadSocial.length > 0 
          ?
            dataEmployee.seguridadSocial.map((item:any) => (
               <>
                <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
                  <Box
                      sx={{
                        textAlign: 'center',
                        height: '100%',
                        alignContent: 'center',
                        textTransform: 'uppercase'
                      }}
                    >
                    <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{item.afiliacion}</Typography>
                  </Box>
                </Grid> 
                <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
                  <Box
                      sx={{
                        textAlign: 'center',
                        height: '100%',
                        alignContent: 'center',
                      }}
                    >
                    <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} > 
                      { item.filePdf 
                          ? <Chip size='small' label="Activo" sx={{ color: "#fff", fontWeight: 700, background: "linear-gradient(45deg, #11998e 0%, #38ef7d 100%)" }} />
                          : 'N/A'
                      } 
                    </Typography>
                  </Box>
                </Grid>
                <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
                  <Box
                      sx={{
                        textAlign: 'center',
                        height: '100%',
                        alignContent: 'center'
                      }}
                    >
                    <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >
                        {
                          item.filePdf 
                           ?
                           <div onClick={ () => openPdfDetail(item.filePdf, "document-employees") }>
                              <DetailsComponents />
                          </div>
                           :
                           'N/A'
                        } 
                        
                    </Typography>
                  </Box>
                </Grid>
                <Grid size={{ xs: 2 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
                  <Box
                      sx={{
                        textAlign: 'center',
                        height: '100%',
                        alignContent: 'center'
                      }}
                    >
                    <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >N/A</Typography>
                  </Box>
                </Grid>
                <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
                  <Box
                      sx={{
                        textAlign: 'center',
                        height: '100%',
                        alignContent: 'center',
                        textTransform: 'uppercase'
                      }}
                    >
                    <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >{item.name}</Typography>
                  </Box>
                </Grid>
               </>
              
              
            ))
          :
          <SinDatos/>

        }

        {/* ***************************************************************************************************
        ****************************************************************************************************
        *********************************       FIN        *************************************************
        ****************************************************************************************************
        *************************************************************************************************** */}










        


       


       {/* ***************************************************************************************************
        ****************************************************************************************************
        *********************************       INICIO        **********************************************
        ****************************************************************************************************
        *************************************************************************************************** */}

        {/* ****** DOCUMENTACIÓN REQUERIDA PARA EL INGRESO ******** */}
        <Grid  size={{ xs: 12 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >DOCUMENTACIÓN REQUERIDA PARA EL INGRESO</Typography>
          </Box>
        </Grid>
        {/* ************** */}



        
        {
          dataEmployee.documentracionRequerida.length > 0 ? (
            <Grid container >
              {dataEmployee.documentracionRequerida.map((item: any, index: number) => (
                <Fragment key={index}>
                  {index % 2 === 0 ? (
                    // Bloque izquierdo
                    <Grid size={6} container spacing={1}>
                      {/* Nombre */}
                      <Grid size={6} sx={{ border: "1px solid #192a56", textAlign: "center", p: 0 }}>
                        <Box
                          sx={{
                            textAlign: "center",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textTransform: "uppercase",
                          }}
                        >
                          <Typography sx={{ fontSize: "0.8rem", p: 0.5 }}>{item.name}</Typography>
                        </Box>
                      </Grid>

                      {/* Valor */}
                      <Grid size={6} sx={{ border: "1px solid #192a56", textAlign: "center", p: 0 }}>
                        <Grid
                          sx={{
                            textAlign: "center",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography sx={{ fontSize: "0.8rem", p: 0.5 }}>
                            {item.status ? (
                              item.hasFile ? (
                                <div onClick={() => openPdfDetail(item.filePdf, "document-employees")}>
                                  <DetailsComponents />
                                </div>
                              ) : (
                                "OK"
                              )
                            ) : (
                              
                              item.status ? (
                                "OK"
                              ) : (
                                "N/A"
                              )

                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : (
                    // Bloque derecho
                    <Grid size={6} container spacing={1}>
                      {/* Nombre */}
                      <Grid size={6} sx={{ border: "1px solid #192a56", textAlign: "center", p: 0 }}>
                        <Grid
                          sx={{
                            textAlign: "center",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textTransform: "uppercase",
                          }}
                        >
                          <Typography sx={{ fontSize: "0.8rem", p: 0.5 }}>{item.name}</Typography>
                        </Grid>
                      </Grid>

                      {/* Valor */}
                      <Grid size={6} sx={{ border: "1px solid #192a56", textAlign: "center", p: 0 }}>
                        <Grid
                          sx={{
                            textAlign: "center",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography sx={{ fontSize: "0.8rem", p: 0.5 }}>
                            {item.status ? (
                              item.hasFile ? (
                                <div onClick={() => openPdfDetail(item.filePdf, "document-employees")}>
                                  <DetailsComponents />
                                </div>
                              ) : (
                                "OK"
                              )
                            ) : (
                              
                              item.status ? (
                                "OK"
                              ) : (
                                "N/A"
                              )

                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Fragment>
              ))}
            </Grid>
          ) : (
            <SinDatos />
          )
        }




        {/* ***************************************************************************************************
        ****************************************************************************************************
        *********************************       FIN        *************************************************
        ****************************************************************************************************
        *************************************************************************************************** */}



















        





        {/* ************** */}
        <Grid  size={{ xs: 12 }} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center', border: "1px solid #192a56", color: 'white', background: '#192a56',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem' }} >DOCUMENTOS CÓNYUGUE DEL ASPIRANTE E HIJOS</Typography>
          </Box>
        </Grid>
        {/* ************** */}


        

        {
          dataEmployee.beneficiaries.length > 0 ? (
            <Grid container size={{ xs: 12, md: 12 }}>
              {dataEmployee.beneficiaries.map((item: any, index: number) => (
                <Fragment key={index}>
                  {index % 2 === 0 ? (
                    // Bloque izquierdo
                    <Grid size={6} container spacing={1}>
                      {/* Nombre */}
                      <Grid size={6} sx={{ border: "1px solid #192a56", textAlign: "center", p: 0 }}>
                        <Box
                          sx={{
                            textAlign: "center",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textTransform: "uppercase",
                          }}
                        >
                          <Typography sx={{ fontSize: "0.8rem", p: 0.5 }}> { item.type_document.label || 'N/A' + ' ' + item.parentesco } </Typography>
                        </Box>
                      </Grid>

                      {/* Valor */}
                      <Grid size={6} sx={{ border: "1px solid #192a56", textAlign: "center", p: 0 }}>
                        <Grid
                          sx={{
                            textAlign: "center",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography sx={{ fontSize: "0.8rem", p: 0.5 }}>
                            {item.status ? (
                              item.documento_beneficiario ? (
                                <div onClick={() => openPdfDetail(item.documento_beneficiario, "document-beneficiary")}>
                                  <DetailsComponents />
                                </div>
                              ) : (
                                "OK"
                              )
                            ) : (
                              
                              item.status ? (
                                "OK"
                              ) : (
                                "N/A"
                              )

                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : (
                    // Bloque derecho
                    <Grid size={6} container spacing={1}>
                      {/* Nombre */}
                      <Grid size={6} sx={{ border: "1px solid #192a56", textAlign: "center", p: 0 }}>
                        <Grid
                          sx={{
                            textAlign: "center",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textTransform: "uppercase",
                          }}
                        >
                          <Typography sx={{ fontSize: "0.8rem", p: 0.5 }}> { item.type_document.label || 'N/A' + ' ' + item.parentesco } </Typography>
                        </Grid>
                      </Grid>

                      {/* Valor */}
                      <Grid size={6} sx={{ border: "1px solid #192a56", textAlign: "center", p: 0 }}>
                        <Grid
                          sx={{
                            textAlign: "center",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography sx={{ fontSize: "0.8rem", p: 0.5 }}>
                            {item.status ? (
                              item.documento_beneficiario ? (
                                <div onClick={() => openPdfDetail(item.documento_beneficiario, "document-beneficiary")}>
                                  <DetailsComponents />
                                </div>
                              ) : (
                                "OK"
                              )
                            ) : (
                              
                              item.status ? (
                                "OK"
                              ) : (
                                "N/A"
                              )

                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Fragment>
              ))}
            </Grid>
          ) : (
            <SinDatos />
          )
        }

        


        {/* *********** */}
       {/* <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >REGISTRO CIVIL HIJOS</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >N/A</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >TARJETA DE IDENTIDAD (Mayores de 8 años)</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >N/A</Typography>
          </Box>
        </Grid> */}
        {/* *********** */}



        {/* *********** */}
       {/* <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >¿SERÁN BENEFICIARIOS DE SEGURIDAD SOCIAL?</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >N/A</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >OBSERVACIONES</Typography>
          </Box>
        </Grid>
        <Grid size={{ xs: 3}} style={{border: "1px solid #192a56", textAlign: 'center',padding: 0}}>
          <Box
              sx={{
                textAlign: 'center',
                height: '100%',
                alignContent: 'center'
              }}
            >
             <Typography sx={{ fontSize: '0.8rem', padding: 0.5 }} >&nbsp;</Typography>dd
          </Box>
        </Grid> */}
        {/* *********** */}



      </Grid>
    
     
    </div>
  )
}
